module.exports = __webpack_public_path__ + "img/video.9893c39f.png";